import React from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';
import { Icons } from '@/utils/Icons';

type FloatingInputProps = {
  label: string;
  register: UseFormRegisterReturn;
  error?: FieldError;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const FloatingInput: React.FC<FloatingInputProps> = ({
  label,
  type = 'text',
  register,
  error,
  required = true,
  ...rest
}) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const isPassword = type === 'password';

  return (
    <div className="relative">
      <input
        type={isPassword && showPassword ? 'text' : type}
        placeholder=" "
        required={required}
        autoComplete="new-password"
        {...register}
        {...rest}
        onChange={(e) => {
          let value = e.target.value;

          // Remove all spaces completely
          value = value.replace(/\s/g, '');

          // Allow only numbers for tel input
          if (type === 'tel') {
            value = value.replace(/\D/g, '');
          }

          e.target.value = value;

          register.onChange(e);
          rest.onChange?.(e);
        }}
        onBlur={(e) => {
          register.onBlur(e);
          rest.onBlur?.(e);
        }}
        className={`
          peer w-full bg-transparent border-b border-gray-600
          pb-2 pt-6 text-xs text-white
          focus:outline-none focus:border-primary
          transition-colors duration-200
          placeholder-transparent
          
          autofill:bg-transparent
          autofill:text-white
          
          ${isPassword ? 'pr-10' : ''}
        `}
      />

      <label
        className="
          pointer-events-none absolute left-0
          text-xs transition-all duration-200
          
          top-5 text-gray-400
          
          peer-focus:top-0
          peer-focus:text-[12px]
          peer-focus:text-primary
          
          peer-valid:top-0
          peer-valid:text-[12px]
          peer-valid:text-primary
        "
      >
        {label}
      </label>

      {isPassword && (
        <button
          type="button"
          onClick={() => setShowPassword((prev) => !prev)}
          className="
            absolute right-0 top-5
            text-gray-400 hover:text-white
            transition-colors
          "
        >
          {showPassword ? <Icons.Eye size={18} /> : <Icons.EyeSlash size={18} />}
        </button>
      )}

      {error && <p className="mt-1 text-xs text-red-500">{error.message}</p>}
    </div>
  );
};
